import { gql } from '@apollo/client';

// TODO: remove this custom query once we remove ALL flags related to org level settings
export const buildGetOrgLevelSettings = flags => {
  const {
    isRiseAiConversationalGptEnabled = false,
    isRiseAIInsightsReportEnabled = false,
    isAutoRemediationsSettingsEnabled = false,
    isSecretScanningSettingsEnabled = false,
    isAdvancedSettingsEnabled = false
  } = flags;

  const fields = ['idleTimoutEnabled', 'idleTimeoutSeconds'];

  // AI Settings fields
  if (isRiseAiConversationalGptEnabled) {
    fields.push('riseAiConversationalGptEnabled');
  }
  if (isRiseAIInsightsReportEnabled) {
    fields.push('riseAiInsightsReportEnabled');
  }

  // Auto-Remediations Settings fields
  if (isAutoRemediationsSettingsEnabled) {
    fields.push('kernelVulnerabilitiesEnabled', 'status', 'justification', 'response');
  }

  // Secret Scanning Settings fields
  if (isSecretScanningSettingsEnabled) {
    fields.push('verifyCredentialsEnabled');
  }

  // Advanced Settings fields (MethodSettings: enabled + confidence)
  if (isAdvancedSettingsEnabled) {
    const advancedSettingsField = '{ enabled confidence componentCount }';
    fields.push(
      `symbolIndexEnabled ${advancedSettingsField}`,
      `kernelModuleEnabled ${advancedSettingsField}`,
      `curatedHashEnabled ${advancedSettingsField}`,
      `legacyHashEnabled ${advancedSettingsField}`,
      `packageManifestEnabled ${advancedSettingsField}`,
      `signatureEnabled ${advancedSettingsField}`,
      `peMetaDataEnabled ${advancedSettingsField}`,
      `libraryVersionEnabled ${advancedSettingsField}`,
      `libraryNameEnabled ${advancedSettingsField}`,
      `binaryFingerprintEnabled ${advancedSettingsField}`,
      `userModifiedEnabled ${advancedSettingsField}`,
      `advancedSettingsJobsProcessing`
    );
  }

  const queryString = `
    query getOrgLevelSettings {
      orgLevelSettings {
        ${fields.join('\n')}
      }
    }
  `;

  return gql(queryString);
};

export const buildUpdateOrgLevelSettings = flags => {
  // Mutation structure doesn't change based on flags, only the input fields sent
  // The mutation itself always accepts the same input type
  return gql`
    mutation updateOrgLevelSettings($args: OrgLevelSettingsInput!) {
      updateOrgLevelSettings(args: $args) {
        err
      }
    }
  `;
};

// TODO: use this query instead of the custom one above once we remove ALL flags related to org level settings
export const UPDATE_ORG_LEVEL_SETTINGS = gql`
  mutation updateOrgLevelSettings($args: OrgLevelSettingsInput!) {
    updateOrgLevelSettings(args: $args) {
      err
    }
  }
`;

// TODO: use this query instead of the custom one above once we remove ALL flags related to org level settings
export const GET_ORG_LEVEL_SETTINGS = gql`
  query getOrgLevelSettings {
    orgLevelSettings {
      idleTimoutEnabled
      idleTimeoutSeconds
      riseAiConversationalGptEnabled
      riseAiInsightsReportEnabled
      kernelVulnerabilitiesEnabled
      status
      justification
      response
      verifyCredentialsEnabled
      symbolIndexEnabled {
        enabled
        confidence
      }
      kernelModuleEnabled {
        enabled
        confidence
      }
      curatedHashEnabled {
        enabled
        confidence
      }
      legacyHashEnabled {
        enabled
        confidence
      }
      packageManifestEnabled {
        enabled
        confidence
      }
      signatureEnabled {
        enabled
        confidence
      }
      peMetaDataEnabled {
        enabled
        confidence
      }
      libraryVersionEnabled {
        enabled
        confidence
      }
      libraryNameEnabled {
        enabled
        confidence
      }
      binaryFingerprintEnabled {
        enabled
        confidence
      }
    }
  }
`;

export const GET_ORG_LEVEL_INFORMATION = gql`
  query orgLevelInformation($args: OrgLevelInformationInput!) {
    orgLevelInformation(args: $args) {
      lastUpdatedAt
    }
  }
`;

/**
 * Org-level identified components preview (advanced-settings feature flag).
 * Pass current identification method toggles as args (IdentifiedComponentsPreviewInput) to get before/after counts per component type.
 */
export const GET_IDENTIFIED_COMPONENTS_PREVIEW = gql`
  query identifiedComponentsPreview($args: IdentifiedComponentsPreviewInput!) {
    identifiedComponentsPreview(args: $args) {
      application {
        beforeCount
        afterCount
      }
      framework {
        beforeCount
        afterCount
      }
      library {
        beforeCount
        afterCount
      }
      container {
        beforeCount
        afterCount
      }
      device {
        beforeCount
        afterCount
      }
      kernel {
        beforeCount
        afterCount
      }
      package {
        beforeCount
        afterCount
      }
      kernelModule {
        beforeCount
        afterCount
      }
      os {
        beforeCount
        afterCount
      }
    }
  }
`;
